import { apiClient } from '~/adapters/apiClient';
import log from '~/logger';
export async function fetchExpressions(params) {
    try {
        const queryParams = params
            ? {
                expressionName: params.expressionName,
                expressionTypeId: params.expressionTypeId,
                brandId: params.brandId,
                divisionId: params.divisionId,
                fieldOfPlayId: params.fieldOfPlayId,
                genderId: params.genderId,
                ageId: params.ageId,
                specialEdition: params.specialEdition,
                page: params.page,
                count: params.count,
                sort: params.sort
            }
            : undefined;
        return await apiClient.get('/product_planning/expressions/v1', 'pulse-projects', queryParams);
    }
    catch (error) {
        log.error('Failed to fetch expressions', {
            error: error instanceof Error ? error.message : 'Unknown error',
            params
        });
        return { pages: { totalPages: 0, totalResources: 0 }, objects: [] };
    }
}
export async function fetchExpressionById(id) {
    try {
        const data = await apiClient.get(`/product_planning/expressions/v1/${id}`, 'pulse-projects');
        return data;
    }
    catch (error) {
        log.error('Failed to fetch expression by ID', {
            error: error instanceof Error ? error.message : 'Unknown error',
            expressionId: id
        });
        return null;
    }
}
export async function fetchExpressionByHandle(handle) {
    try {
        const data = await apiClient.get('/product_planning/expressions/v1', 'pulse-projects', { handle });
        return data.objects?.[0] ?? null;
    }
    catch (error) {
        log.error('Failed to fetch expression by handle', {
            error: error instanceof Error ? error.message : 'Unknown error',
            handle
        });
        return null;
    }
}
